import type { Menu, Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSMenu, useCMSReference } from '@swf/cms';
import useTouchSupported from '@swf/core/hooks/useTouchSupported';

import styles from './CMSNavigation.scss';

interface Props {
  reference: Reference;
  maxDepth: number;
}

const CMSNavigationItem: React.FC<Props> = ({ reference, maxDepth }) => {
  const menu = useCMSReference<Menu>(reference) as Menu;
  const isTouchSupported = useTouchSupported();

  return menu ? (
    <CMSMenu
      menu={menu}
      depth={0}
      maxDepth={1}
      internalItem={styles.navItem}
      activeItem={styles.navItemActive}
      tagName={isTouchSupported && maxDepth > 1 && !!menu.children.length ? 'span' : undefined}
    />
  ) : null;
};

export default CMSNavigationItem;
